module.exports = __webpack_public_path__ + "img/dingzhiyansemozhenxingdai.min.d3c6bf91.png";